import React, { useEffect, useState, useContext, useRef } from "react";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import { Mail, Phone } from "react-feather";
import { Container, Box, Typography, Drawer, Grid } from "@mui/material";
import { CHANGE_LANG } from "context/actions/auth";

import { GlobalContext } from "context";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

// utils
import useWindowSize from "utils/useWindowSize";

// icons
import { X, Menu as MenuIcon } from "react-feather";
import LogoFull from "public/Logo.png";
import LogoFullEng from "public/Logo.png";

//actions

import { getPageList } from "context/actions/pages";

const HeaderHeight = 140;

const Header = () => {
  const { sizes } = useWindowSize();
  const { t } = useTranslation();
  const router = useRouter();
  const divRef = useRef(null);
  const divRef2 = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);

  const { state, dispatch } = useContext(GlobalContext);

  const [showMenu, setShowMenu] = useState(false);
  const [menus, setMenus] = useState([]);

  const [absoluteMenus, setAbsoluteMenus] = useState([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        divRef.current &&
        !divRef.current.contains(event.target) &&
        !divRef2.current.contains(event.target)
      ) {
        setAbsoluteMenus([]);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollTop(position);
  };

  useEffect(() => {
    getMenus();
  }, []);

  const getMenus = async () => {
    const datas = await getPageList(true);

    if (datas.status === "success") {
      setMenus(datas.data);
    }
  };

  const handleMenuButtonClick = () => {
    setShowMenu((prev) => !prev);
  };

  const handleDrawerClose = () => {
    setShowMenu(false);
  };

  const handleRoteClick = (menu) => {
    showMenu && handleDrawerClose();

    if ((menu.url && menu.url.charAt(0) === "/") || !menu.url)
      router.push(menu.url ? "/" + menu.url : "/content/" + menu.id);
    else {
      const newWindow = window.open(menu.url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  const RenderMenu = ({
    position,
    menu,
    showsMenu = true,
    type = "header",
  }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const onMouseEnter = (e) => {
      setShowSubMenu(true);
    };
    const onMouseLeave = (e) => {
      setShowSubMenu(false);
    };

    return (
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ position: "relative" }}
      >
        <li
          style={{
            position: "relative",
            height:
              type === "drawer" ? 30 :  80,
            display: "flex",
            marginTop:  0,
            justifyContent: "left",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            cursor: "pointer",
            textTransform: "uppercase",
            fontSize: 12,
            borderRadius: 6,
            color: "white",
            backgroundColor:
               "",
          }}
          className={`transition-colors duration-300`}
        >
          {menu.children && menu.children.length > 0 ? (
            i18n.language === "mn" ? (
              menu.name
            ) : (
              menu.nameEng
            )
          ) : (
            <Link
              href={menu.url ? menu.url : "/content/" + menu.id}
              passHref
              target={
                (menu.url && menu.url.charAt(0) === "/") || !menu.url
                  ? "_self"
                  : "_blank"
              }
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Link>
          )}
        </li>
        <div
          style={{
            position: "absolute",
            top: 63,
            left: position > 2 ? null : "0%",
            right: position > 2 ? "20%" : null,
            backgroundColor: "white",
            borderRadius: 2,
            borderRadius: 10,
            zIndex: 100,

            boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.3)",
          }}
        >
          <ul
            style={{
              position: "relative",
            }}
          >
            {menu.children.map((m, ind) => {
              return (
                <RenderSubMenu key={ind} menu={m} showsMenu={showSubMenu} />
              );
            })}
          </ul>
        </div>
      </div>
    );
  };

  const RenderSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const onMouseEnter = (e) => {
      setShowSubMenu(true);
    };
    const onMouseLeave = (e) => {
      setShowSubMenu(false);
    };

    return (
      <Box
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ position: "relative" }}
      >
        <li
          style={{
            position: "relative",
            color: "gray",
            cursor: "pointer",
            display: showsMenu ? "block" : "none",
            backgroundColor: showSubMenu ? "#bee0f8" : "#fff",
            paddingLeft: 40,
            paddingRight: 40,
          }}
        >
          {menu.children && menu.children.length > 0 ? (
            <Typography noWrap variant="body2" className="p-2">
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          ) : (
            <Link
              href={menu.url ? menu.url : "/content/" + menu.id}
              passHref
              target={
                (menu.url && menu.url.charAt(0) === "/") || !menu.url
                  ? "_self"
                  : "_blank"
              }
            >
              <Typography noWrap variant="body2" className="p-2">
                {i18n.language === "mn" ? menu.name : menu.nameEng}
              </Typography>
            </Link>
          )}
        </li>
        <div
          style={{
            position: "absolute",
            right: "95%",
            maxWidth: 600,
            top: 0,
            backgroundColor: "white",
            borderRadius: 2,
            borderRadius: 10,
            zIndex: 101,

            boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.3)",
          }}
        >
          <ul
            style={{
              position: "relative",
            }}
          >
            {menu.children.map((m, ind) => {
              return (
                <RenderSubMenu key={ind} menu={m} showsMenu={showSubMenu} />
              );
            })}
          </ul>
        </div>
      </Box>
    );
  };

  const RenderRoundSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const onMouseEnter = (e) => {
      setShowSubMenu(true);
    };
    const onMouseLeave = (e) => {
      setShowSubMenu(false);
    };

    const onClickMenu = () => {
      if (menu.children && menu.children.length > 0) {
        setAbsoluteMenus(menu.children);
      } else {
        if (menu.url) {
          if (menu.url.charAt(0) === "/") {
            router.push(menu.url); // Navigate internally
            setAbsoluteMenus([]);
          } else {
            window.open(menu.url, "_blank"); // Open externally
          }
        } else {
          router.push("/content/" + menu.id); // Default internal navigation

          setAbsoluteMenus([]);
        }
      }
    };

    return (
      <Grid item lg={3} md={3} sm={6} xs={12} style={{}} onClick={onClickMenu}>
        <div
          style={{
            position: "relative",
            cursor: "pointer",
            minHeight: 80,
            // padding: 8,
            padding: "18px 40px 18px 40px",
          }}
          className="bg-grayddd hover:bg-blue035 text-black333 hover:text-white"
        >
          {menu.children && menu.children.length > 0 ? (
            <Typography
              variant="body2"
              className="text-center font-bold uppercase"
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              className="text-center font-bold uppercase"
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          )}
        </div>
      </Grid>
    );
  };

  const RenderToggleMenu = ({ menu, showsMenu = true, type = "header" }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const onMouseEnter = (e) => {
      setShowSubMenu(!showSubMenu);
    };
    const onMouseLeave = (e) => {
      setShowSubMenu(false);
    };

    return (
      <div onClick={onMouseEnter}>
        <li
          style={{
            position: "relative",
            height: type === "drawer" ? 30 : 80,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            cursor: "pointer",
            color: type === "drawer" ? "black" : "white",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          {menu.children && menu.children.length > 0 ? (
            <>
              {i18n.language === "mn" ? menu.name : menu.nameEng}
              <div>{showSubMenu ? "-" : "+"}</div>
            </>
          ) : (
            <Typography
              variant={"h4"}
              style={{
                color: "#000",
                fontWeight: "700",
                cursor: "pointer",
                marginRight: 46,
                height: "fit-content",

                "&:hover": {
                  color: "#a19d9d",
                },
              }}
              onClick={() => handleRoteClick(menu)}
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          )}
        </li>

        {menu.children.map((m, ind) => {
          return (
            <RenderToggleSubMenu key={ind} menu={m} showsMenu={showSubMenu} />
          );
        })}
      </div>
    );
  };
  const RenderToggleSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const onMouseEnter = (e) => {
      setShowSubMenu(true);
    };
    const onMouseLeave = (e) => {
      setShowSubMenu(false);
    };

    return showsMenu ? (
      <div>
        <li
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={{
            position: "relative",
            color: "gray",
            cursor: "pointer",
            display: "flex",
            marginLeft: 30,
            padding: 10,
          }}
        >
          <Typography variant={"h4"} onClick={() => handleRoteClick(menu)}>
            {i18n.language === "mn" ? menu.name : menu.nameEng}
          </Typography>
        </li>

        <div style={{ position: "relative", left: 30 }}>
          {menu.children.map((m, ind) => {
            return (
              <RenderToggleSubMenu key={ind} menu={m} showsMenu={showSubMenu} />
            );
          })}
        </div>
      </div>
    ) : (
      <></>
    );
  };

  return (
    <div style={{ paddingBottom: absoluteMenus?.length ? 0 : 0 }}>
      <Container
        spacing={0}
        maxWidth={false}
        disableGutters={true}
        style={{
          height: 30,
          backgroundColor: "#f2f2f2",
        }}
      >
        <Container
          maxWidth={"lg"}
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Link href={"#contact"} passHref>
            <Typography
              variant={"body1"}
              className="font-bold mr-10 text-gray-500 hover:text-gray-600"
            >
              {t("send_feed")}
            </Typography>
          </Link>
        </Container>
      </Container>
      <Container
        maxWidth={false}
        ref={divRef2}
        disableGutters={true}
        style={{
          height: HeaderHeight-(sizes.sm ? 45 : 0),
          backgroundColor: "#fff",
          zIndex: 99,
          top: 0,
          borderBottom: "1px solid",
          borderColor: "#cbcbcb75!important",
          position: scrollTop > 30 ? "fixed" : "absolute",
          top: scrollTop > 30 ? 0 : 30,

          zIndex: 9999,
        }}
        className="flex flex-col"
      >
        <Container
          maxWidth={"lg"}
          style={{
            height: HeaderHeight - 45,
          }}
          className="!flex !flex-row justify-between items-center"
        >
          <Link href={"/"} passHref>
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Image
                width={sizes.sm ? 150 : 200}
                src={i18n.language === "mn" ? LogoFull : LogoFullEng}
                alt=""
                objectFit={"cover"}
              />
            </Box>
          </Link>
          {!sizes.sm ? (
            <>
            <a 
              href="mailto:bayangol_tu@bgd.ub.gov.mn"
              className="ml-auto flex flex-row items-center"
              aria-label="Email"
            >
                <Box
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 30,
                    // background: "linear-gradient(135deg, #FFD38A 0%, #FFB03D 100%)",

                  }}
                  className="flex justify-center items-center flex-nowrap "
                >
                  <Mail size={"22"} style={{}}  className="!text-secondary-main"/>
                </Box>
                <Typography
                  variant={"body1"}
                  className="font-bold ml-2 mr-1  text-nowrap"
                  style={{ color: "#1e1c55" }}
                >
                  {`bayangol_tu@bgd.ub.gov.mn`}
                </Typography>
                </a>

            <a 
              href="tel:+97670110018"
              className=" flex flex-row items-center"
              aria-label="Phone"
            >
                <Box
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 30,
                    // background: "linear-gradient(135deg, #FFD38A 0%, #FFB03D 100%)",

                  }}
                  className="flex justify-center items-center flex-nowrap"
                >
                  <Phone size={"22"} style={{}}  className="!text-secondary-main"/>
                </Box>
                <Typography
                  variant={"body1"}
                  className="font-bold ml-2 mr-1  text-nowrap"
                  style={{ color: "#1e1c55" }}
                >
                  {`(+976) 70110018`}
                </Typography>
              </a>
            </>
          ) : (
            <>
              <MenuIcon
                style={{
                  // color: "#FFF",
                  marginLeft: "auto",
                  width: 40,
                  height: 40,
                  cursor: "pointer",
                }}
                size={"14"}
                onClick={handleMenuButtonClick}
                className="!text-primary-main"
              />
              <Drawer
                anchor="right"
                onClose={handleDrawerClose}
                open={showMenu}
                transitionDuration={{
                  enter: 500,
                  exit: 500,
                }}
                variant="temporary"
                style={{ zIndex: 10000 }}
                PaperProps={{
                  sx: { width: "100vw" }, // Makes the Drawer full width
                }}
              >
                <Box
                  className={[
                    showMenu && {
                      animation: `${{
                        "0%": {
                          opacity: 0.4,
                          transform: "translateX(100px)",
                        },
                        "100%": {
                          opacity: 1,
                          transform: "translateX(0)",
                        },
                      }} `,
                      animationDelay: "350ms",
                      animationFillMode: "forwards",
                      opacity: 0,
                    },
                  ]}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: 20,
                    height: "100%",
                  }}
                >
                  <X
                    color={"#000"}
                    style={{
                      color: "#000",
                      marginTop: 20,
                      marginBottom: 6,
                      marginLeft: "auto",
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                      minHeight: 40,
                    }}
                    size={"18"}
                    onClick={handleDrawerClose}
                  />

                  {menus.map((m, ind) => {
                    return (
                      <RenderToggleMenu key={ind} menu={m} type="drawer" />
                    );
                  })}
                </Box>
              </Drawer>
            </>
          )}
        </Container>
         {!sizes.sm && (
        <Container
          maxWidth={"false"}
          style={{
            height: 45,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // background:
            //   "linear-gradient(135deg, rgba(10, 36, 88, 0.8) 0%, #1e1c55 100%)",
          }}
          className="bg-[radial-gradient(circle,_#045A79E6_0%,_#023C52FF_95%)]"

        >
         
            <Box
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <ul
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {menus.map((m, ind) => {
                  return <RenderMenu key={ind} position={ind} menu={m} />;
                })}
              </ul>
            </Box>
        </Container>
          )}
      </Container>

      {absoluteMenus?.length > 0 && (
        <Container
          ref={divRef}
          maxWidth={false}
          style={{
            backgroundColor: "#fff",
            zIndex: 99,
            borderBottom: "1px solid",
            borderColor: "#cbcbcb75",
            position: scrollTop > 43 ? "fixed" : "absolute",
            top: scrollTop > 43 ? 83 : 123,
            boxShadow: "0px 9px 9px rgba(0, 0, 0, 0.05)",
            zIndex: 9999,
          }}
        >
          <Container
            maxWidth={"lg"}
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Grid
              container
              spacing={4}
              style={{
                paddingTop: 20,
                paddingBottom: 20,
              }}
            >
              {absoluteMenus.map((d, ind) => {
                return <RenderRoundSubMenu key={ind} menu={d} />;
              })}
            </Grid>
          </Container>
        </Container>
      )}
    </div>
  );
};

export default Header;
